import { GivelifyButton, GivelifyLabel, GivelifyRadio } from '@givelify/ui';
import { styled } from '@mui/material/styles';

export const Content = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    '&::-webkit-scrollbar': {
        width: 1,
    },
    [theme.breakpoints.down('mobile')]: {
        overflowY: 'auto',
        display: 'block',
    },
}));

export const MainBox = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    padding: '89px',
    paddingTop: 0,
    [theme.breakpoints.down('mobile')]: {
        padding: 0,
    },
}));

export const NumberedLine = styled(GivelifyLabel)(({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(1),
}));

export const RadioBox = styled('div')(({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(4),
    margin: theme.spacing(2, 0),
    justifyContent: 'flex-start',
    [theme.breakpoints.down('mobile')]: {
        flexDirection: 'column',
        gap: theme.spacing(2),
    },
    '& .MuiTypography-root': {
        fontWeight: 800,
        cursor: 'pointer',
    },
}));

export const RadioButton = styled(GivelifyRadio)(({ theme }) => ({
    marginRight: theme.spacing(2),
}));

export const DownloadHelp = styled(GivelifyButton)(({ theme }) => ({
    margin: theme.spacing(0, 0, 5, 0),
    display: 'block',
    [theme.breakpoints.down('mobile')]: {
        display: 'block',
        margin: theme.spacing(0, 'auto', 4, 'auto'),
    },
}));

export const PreviewBox = styled('div')(({ theme }) => ({
    border: '1px solid #E3E3E3',
    borderRadius: '4px',
    marginTop: 4,
    marginBottom: 16,
    display: 'inline-flex',
    [theme.breakpoints.down('mobile')]: {
        textAlign: 'center',
        display: 'block',
        paddingLeft: 16,
        paddingRight: 16,
    },
}));

export const PreviewImage = styled('img')(({ theme }) => ({
    margin: '40px 75px',
    [theme.breakpoints.down('mobile')]: {
        margin: '16px 0',
        width: '100%',
    },
}));
